<p-card header="Info">
  <div class="grid grid-cols-12">
    <app-form-text-input [form]="form" [twoColumns]="true" id="mandant" label="USERS.MANDANT"></app-form-text-input>

    <app-form-text-input
      [form]="form"
      [twoColumns]="true"
      id="creatorName"
      label="VARIABLES.CREATOR"></app-form-text-input>

    <app-form-text-input
      [form]="form"
      [twoColumns]="true"
      id="creatorEmail"
      label="VARIABLES.CREATOR_EMAIL"></app-form-text-input>

    @if (variableApproval.variable?.isBetriebsVariable) {
      <app-form-text-input
        [form]="form"
        [twoColumns]="true"
        id="variable.parentTacsId"
        label="VARIABLES.PARENT_TACS_ID"></app-form-text-input>
    }

    @if (variableApproval.variable?.isBetriebsVariable) {
      <app-form-text-input
        [form]="form"
        [twoColumns]="true"
        id="variable.parentName"
        label="VARIABLES.PARENT_NAME"></app-form-text-input>
    }

    <app-form-text-input
      [form]="form"
      [twoColumns]="true"
      id="variable.tacsId"
      label="VARIABLES.TACS_ID"></app-form-text-input>

    <app-form-text-input
      [form]="form"
      [label]="variableApproval.variable?.isBetriebsVariable ? 'GLOBAL.NAME' : 'VARIABLES.NAME'"
      [twoColumns]="true"
      id="variable.name"></app-form-text-input>

    @if (!variableApproval.variable?.isBetriebsVariable) {
      @for (language of languages; track $index) {
        <app-form-text-input
          [form]="form"
          [id]="'variable.customName.' + language"
          [label]="'GLOBAL.NAME_' + language"
          [twoColumns]="true"></app-form-text-input>
      }
    }
  </div>
</p-card>

@for (message of variableApproval.messages; track message.id) {
  <p-card [header]="message.creatorName" [styleClass]="message.isRodix ? 'rodix' : 'customer'">
    <textarea [autoResize]="true" [disabled]="true" [value]="message.message" pTextarea rows="3"></textarea>
    <p style="color: grey; text-align: right">{{ message.created | date: 'dd.MM.yyyy HH:mm' }}</p>
  </p-card>
}

<p-card [header]="name" [styleClass]="isRodixAdmin() ? 'rodix' : 'customer'">
  <textarea [autofocus]="true" [autoResize]="true" [formControl]="commentControl" pTextarea rows="3"></textarea>
  <ng-template pTemplate="footer">
    <p-button
      (onClick)="comment()"
      [disabled]="commentControl.invalid"
      [label]="'ACTIONS.COMMENT' | translate"
      [style]="{ 'margin-right': '0.5rem' }"
      icon="fal fa-comment-plus"></p-button>
    @if (isRodixAdmin()) {
      <p-button
        (onClick)="accept()"
        [disabled]="commentControl.invalid"
        [label]="'ACTIONS.ACCEPT' | translate"
        [style]="{ 'margin-right': '0.5rem' }"
        icon="fal fa-check"
        styleClass="p-button-success"></p-button>
    }
    @if (isRodixAdmin()) {
      <p-button
        (onClick)="reject()"
        [disabled]="commentControl.invalid"
        [label]="'ACTIONS.REJECT' | translate"
        icon="fal fa-times"
        styleClass="p-button-danger"></p-button>
    }
  </ng-template>
</p-card>
